<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpWidgetCard>
    <ItpBox
      alignItems="center"
      slot="header"
    >
      <strong>
        {{ 'Services and Fees'|pgettext('Contract') }}
      </strong>
      <ItpButton
        :text="'Add service...'|gettext"
        variant="light"
        size="sm"
        class="ml-auto"
        v-if="!readonly"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <BListGroup>
      <BListGroupItem
        v-if="!contract.services || !contract.services.length"
      >
        <ItpText>
          {{ 'No services have been added yet.'|pgettext('Contract') }}
        </ItpText>
      </BListGroupItem>
      <BListGroupItem
        :key="service.id"
        v-for="service in filterItems(contract.services)"
      >
        <ItpBox
          alignItems="center"
        >
          <UcContractServiceCard
            :item="service"
            :style="b_5917154787680107_style"
          >
          </UcContractServiceCard>
          <b-dropdown
            size="sm"
            toggle-class="btn-default-borderless"
            no-caret
            variant="none"
            class="ml-auto mb-auto"
          >
            <ItpIcon
              fa="ellipsis-v"
              class="mx-1"
              slot="button-content"
            >
            </ItpIcon>
            <b-dropdown-item-button
              @click.prevent.stop="evh_294572930540096_clickPreventStop($event, {service})"
            >
              <ItpText
                :text="'Edit'|pgettext('Command')"
              >
              </ItpText>
            </b-dropdown-item-button>
          </b-dropdown>
        </ItpBox>
        <hr>
        </hr>
        <UcContractServiceFees
          :contract="contract"
          :service="service"
          :reload="lastLoaded"
          :readonly="readonly"
          @reload="evh_6027561141562583_reload($event, {service})"
        >
        </UcContractServiceFees>
      </BListGroupItem>
    </BListGroup>
  </ItpWidgetCard>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcContractServices extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  filterItems(...args: any[]) {
    return _.sortBy(args[0], p => this.isServiceStale(p) ? "_" + p.name : p.id)
  }

  isServiceStale(...args: any[]) {
    const [service] = args;
    return service.valid_to && this.$fn.parseISODate(service.valid_to) < this.today
  }

  @Prop({
    required: true,
    type: Object,
  })
  contract!: object;

  @Watch('contract')
  onContract(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contract")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  today!: any;

  async $$load_today() {
    return new Date()
  }

  displayHelper!: any;
  ux!: any;
  b_5917154787680107_style!: any;
  dataMembers = ['today', 'displayHelper', 'ux', 'b_5917154787680107_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        today: null,
        displayHelper: null,
        ux: null,
        b_5917154787680107_style: {
          "min-width": 0,
        }
        ,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_emit_9018_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8320016629450276_emit_9018, alias=emitReload
    return {
      event: "reload",
    }
  }

  async evh_8320016629450276_close_9017_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_close_9017, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_8320016629450276_showModal_9016_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_9016, alias=undefined
    return {
      name: "ContractServiceEditor",
      props: {
        mode: "addService",
        contract: this.contract,
      }
      ,
    }
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_294572930540096_emit_9022_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_294572930540096_emit_9022, alias=emitReload
    return {
      event: "reload",
    }
  }

  async evh_294572930540096_close_9021_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_294572930540096_close_9021, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_294572930540096_showModal_9020_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_294572930540096_showModal_9020, alias=undefined
    return {
      name: "ContractServiceEditor",
      props: {
        mode: "editService",
        contract: this.contract,
        service: _.cloneDeep($event.scope.service),
      }
      ,
    }
  }

  async evh_294572930540096_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_294572930540096_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_6027561141562583_emit_9024_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_6027561141562583_emit_9024, alias=emitReload
    return {
      event: "reload",
    }
  }

  async evh_6027561141562583_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6027561141562583_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_9014: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_9013: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_8320016629450276_emit_9018: actions.EmitAction;
    evh_8320016629450276_close_9017: actions.EventHandlerImpl;
    act_8320016629450276_showModal_9016: actions.ShowModalAction;
    evh_8320016629450276_clickPreventStop_9015: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_294572930540096_emit_9022: actions.EmitAction;
    evh_294572930540096_close_9021: actions.EventHandlerImpl;
    act_294572930540096_showModal_9020: actions.ShowModalAction;
    evh_294572930540096_clickPreventStop_9019: actions.EventHandlerImpl;
    evh_294572930540096_clickPreventStop: actions.EventHandlerGroup;
    act_6027561141562583_emit_9024: actions.EmitAction;
    evh_6027561141562583_reload_9023: actions.EventHandlerImpl;
    evh_6027561141562583_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_9014 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_9013 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_9014,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_9013],
      }
    );
    const act_8320016629450276_emit_9018 = new actions.EmitAction(
      {
        actionArgs: this.act_8320016629450276_emit_9018_getActionArgs,
        displayName: "emitReload",
        events: [],
      }
    );
    const evh_8320016629450276_close_9017 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_emit_9018,
        event: "close",
        when: this.evh_8320016629450276_close_9017_getWhen,
        displayName: "emitReload",
      }
    );
    const act_8320016629450276_showModal_9016 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_9016_getActionArgs,
        events: [evh_8320016629450276_close_9017],
      }
    );
    const evh_8320016629450276_clickPreventStop_9015 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_9016,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_9015],
      }
    );
    const act_294572930540096_emit_9022 = new actions.EmitAction(
      {
        actionArgs: this.act_294572930540096_emit_9022_getActionArgs,
        displayName: "emitReload",
        events: [],
      }
    );
    const evh_294572930540096_close_9021 = new actions.EventHandlerImpl(
      {
        action: act_294572930540096_emit_9022,
        event: "close",
        when: this.evh_294572930540096_close_9021_getWhen,
        displayName: "emitReload",
      }
    );
    const act_294572930540096_showModal_9020 = new actions.ShowModalAction(
      {
        actionArgs: this.act_294572930540096_showModal_9020_getActionArgs,
        events: [evh_294572930540096_close_9021],
      }
    );
    const evh_294572930540096_clickPreventStop_9019 = new actions.EventHandlerImpl(
      {
        action: act_294572930540096_showModal_9020,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_294572930540096_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_294572930540096_clickPreventStop_9019],
      }
    );
    const act_6027561141562583_emit_9024 = new actions.EmitAction(
      {
        actionArgs: this.act_6027561141562583_emit_9024_getActionArgs,
        displayName: "emitReload",
        events: [],
      }
    );
    const evh_6027561141562583_reload_9023 = new actions.EventHandlerImpl(
      {
        action: act_6027561141562583_emit_9024,
        event: "reload",
        displayName: "emitReload",
      }
    );
    const evh_6027561141562583_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_6027561141562583_reload_9023],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_9014,
      evh_7315092382398562_reload_9013,
      evh_7315092382398562_reload,
      act_8320016629450276_emit_9018,
      evh_8320016629450276_close_9017,
      act_8320016629450276_showModal_9016,
      evh_8320016629450276_clickPreventStop_9015,
      evh_8320016629450276_clickPreventStop,
      act_294572930540096_emit_9022,
      evh_294572930540096_close_9021,
      act_294572930540096_showModal_9020,
      evh_294572930540096_clickPreventStop_9019,
      evh_294572930540096_clickPreventStop,
      act_6027561141562583_emit_9024,
      evh_6027561141562583_reload_9023,
      evh_6027561141562583_reload,
      emitReload: act_6027561141562583_emit_9024,
    }
  }
}

Vue.component("UcContractServices", UcContractServices);

</script>